/**
 * @function Newsletter
 * @description A React component to provide a newsletter subscription form. It accepts the width of the container as a prop. The form utilizes the `react-hubspot-form` to embed a HubSpot form into the component. When a user submits the form, it logs the submission and pushes an event to the data layer for tracking.
 * @param {Object} props - The props object for the component.
 * @param {string} props.classWidth - The width class for styling the component.
 * @example
 *   <Newsletter classWidth="w-8/12" />
 * @returns {ReactElement} Returns the Newsletter subscription form with a title, subscription pitch, and the actual form embedded via HubSpot.
 */
// import HubspotForm from 'react-hubspot-form';
import {Link} from '@shopify/hydrogen';
import { useEffect } from 'react';

export default function Newsletter({classWidth}) {

  const handleOnSubmit = (e) => {
    e.preventDefault();
    // console.log('submit');

    // dataLayer.push({
    //   event: 'generate_lead',
    //   subscription: 'newsletter',
    // });
  };

  return (
    <>
      <div className={`h-full ${classWidth}`}>
        <div className="h-full border-gray-80 border bg-gray-60 rounded-xl flex flex-col mx-auto w-full pt-8 px-8 pb-4 xs:px-4 newsletter-form">
          {/* <h2 className="section-title mb-1 xs:text-center xs:px-0 xs:mb-3 p-0">
            Suscríbete a nuestro Newsletter
          </h2>
          <p className="xs:text-center mb-5">
            Recibirás las novedades y nuestras promociones exclusivas para tí.
          </p> */}

          <iframe
            title="Newsletter"
            name="Registro_Newsletter"
            className="transparent-iframe"
            allowTransparency="true"
            src="https://cloud.mkt-ellibrero.com/Registro_Newsletter"
            allowFullScreen
          />

          {/* <HubspotForm
            portalId="6438710"
            formId="e47451a5-643e-4ddf-b1f3-527c797711b1"
            onSubmit={(e) => handleOnSubmit(e)}
            onReady={(form) => console.log('Form ready!')}
            loading={<div>Loading...</div>}
          /> */}

          {/* <div className="flex flex-col  w-full my-5">
            <div className="flex flex-wrap w-full justify-start">
              <input
                type="text"
                className="rounded-full mr-4 w-7/12 px-4 pt-4 pb-3 xs:w-full text-xs xs:mx-0 xs:mr-0 xs:mb-5"
                placeholder="Escribe aquí tu correo electrónico"
                onChange={handleChange}
              />
              <button
                className="btn-main w-4/12 xs:w-8/12 xs:mt-2 rounded-full bg-purple-120 text-white disabled:bg-gray-400"
                onClick={onSumbit}
                disabled={loading}
              >
                Suscribirme
              </button>
            </div>

            {error && (
              <span className="text-red-400 text-sm mt-2 xs:text-center">
                {error}
              </span>
            )}
            {message && (
              <div className="bg-green-600 rounded-full px-5 w-full py-2 text-white text-sm mt-2">
                {message}
              </div>
            )}
          </div>
          <p className="text-xs xs:text-center">
            *Al hacer click en suscribirme aceptarás nuestras{' '}
            <a href="/" className="font-semibold underline">
              Políticas de privacidad
            </a>
          </p> */}

          <div className="newsletter-aviso mt-1 xs:text-center">
            <p>
              <small>
                Acepto{' '}
                <Link className="underline" to="/aviso-de-privacidad/">
                  Políticas de privacidad
                </Link>{' '}
                de El Librero
              </small>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
